import React from "react";
import { Grid, Typography, Button } from "@mui/material";
import { VisuallyHiddenInput } from "./styles";
import FormCard from "./FormCard";
import CardTitle from "./CardTitle";

function ProfileImage({ formData, uploadFile, classes }) {
	return (
		<
			>
			<CardTitle title="Profile image" />
			<Grid container alignItems="center" pb={2} spacing={2}>
				<Grid
					item
					xs={12}
					sm={6}
				>
					<Button
						component="label"
						className={classes.roundButton}
						role={undefined}
						variant="contained"
						tabIndex={-1}
						onChange={(e) => uploadFile(e)}
					>
						Browse
						<input
							type="file"
							accept="image/*" // This ensures only image files can be selected
							hidden
							onChange={(e) => uploadFile(e)}
						/>
					</Button>
				</Grid>

				<Grid
					item
					xs={12}
					sm={6}
				>
					<Typography
						variant="h6"
						component="h6"
					>
						{formData?.avatar ? "Image selected" : ""}
					</Typography>
				</Grid>

				<Grid
					item
					xs={12}
					sm={6}
				>
					{formData?.avatar ? (
						<Button
							component="label"
							className={classes.roundButton}
							role={undefined}
							variant="outlined"
							tabIndex={-1}
							onChange={(e) => uploadFile(e)}
						>
							Change image
							<VisuallyHiddenInput type="file" />
						</Button>
					) : null}
				</Grid>

				<Grid
					item
					xs={12}
					sm={6}
				>
					<Typography
						variant="h6"
						component="h6"
					>
						{formData?.avatar ? formData?.fileName?.substring(0, 20) + "..." : null}
					</Typography>
				</Grid>
			</Grid>
		</>
	);
}

export default ProfileImage;
